const colors = {
  YELLOW: "#ffcc00",
  ORANGE: "orange",
  WHITE: "#ffffff",
  GRAY: "#f5f5f5",
  GREEN: "green",
  RED: "#d40511",
  DARK_GREY: "#000000a6",
};

export default colors;
